<template>
  <div>
    <section class="pt-[55px] pb-[70px] pc:py-[140px] pc-con-wrapper1">
      <p class="hidden text-lg font-bold text-center pc:text-5xl text-neutral-950 mb-11 pc:block">회원가입</p>
      <div class="px-5 border border-solid py-7 pc:py-11 border-neutral-200 rounded-2xl">
        <div>
          <p class="text-lg font-bold text-center text-neutral-950 mb-7 pc:text-2xl pc:mb-16">
            화상외국어과정 참여를 위한 만 14세 미만 법정 대리인 동의서
          </p>
          <div class="mb-14 pc:mb-11">
            <div
              class="p-5 text-xs border border-solid rounded pc:text-base border-neutral-200 text-neutral-500 mb-2.5 whitespace-pre-line"
            >
              {{ signUser.agentAgreeText }}
              <div
                class="text-xs font-bold cursor-pointer pc:text-xl text-neutral-950 mt-[24px] w-full flex items-center justify-center"
              >
                위 사항에 동의하실 경우 아래 '동의함' 버튼을 눌러주시기 바랍니다.
              </div>
            </div>
            <div>
              <label class="text-xs font-bold cursor-pointer pc:text-base check-label text-neutral-950"
                >위 이용약관의 내용에 동의합니다.
                <input type="checkbox" v-model="signUser.agentAgreeCheckbox" />
                <div class="checkmark"></div>
              </label>
            </div>
          </div>

          <ul class="grid grid-cols-2 gap-2.5 pc:gap-5 pc:max-w-md mx-auto max-w-xs">
            <li
              class="py-4 text-sm font-bold text-center border border-solid rounded cursor-pointer text-neutral-500 pc:py-6 pc:text-xl border-neutral-500"
              @click="signUser.backSignup1()"
            >
              돌아가기
            </li>
            <li
              class="py-4 text-sm font-bold text-center text-white bg-orange-500 rounded cursor-pointer pc:py-6 pc:text-xl"
              @click="signUser.nextSignPage"
            >
              다음
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {},
  setup() {
    const store = useStore();
    const router = useRouter();
    const idxLeSiteMain = store.getters.getIdxLeSiteMain;

    const signUser = reactive({
      agentAgreeCheckbox: false,
      agentAgreeText: `
본 동의서는 귀하(부모님 또는 보호자)의 자녀(만 14세 미만)가 ㈜캐럿솔루션즈에서 진행하는 화상 외국어과정 참여를 위하여
필요한 최소한의 개인정보를 수집·이용·제공하는 것에 대한 귀하의 동의 여부를 확인하기 위한 것입니다.

개인정보 보호법 제22조에 따라 만 14세 미만 아동의 개인정보 수집·이용·제공 시에는
법정대리인(부모님 또는 보호자)의 동의가 필요합니다.
이에 따라 당사는 필요한 범위 내에서 법정대리인의 성명 등 최소한의 정보를 요청할 수 있으며,
동의하실 경우 아래 내용을 충분히 확인하신 후 동의 여부를 결정해 주시기 바랍니다.

귀하(부모님 또는 보호자)의 자녀(만 14세 미만)가 개인정보 수집, 이용, 제공 등에 동의하는 것에 대한 안내 사항입니다.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
[개인정보 처리에 관한 안내]
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

1. 당사는 개인정보 보호법 등 관련 법령을 준수하며,
   서비스 제공에 필요한 최소한의 개인정보만을 적법하고 공정한 절차에 따라 수집·이용합니다.

2. 개인정보 수집 시에는 그 목적, 수집 항목, 보유 및 이용 기간 등을 명확하고 이해하기 쉽게 안내드리고 있으며,
   이용 목적이 달성되거나 보유기간이 경과한 경우 해당 정보는 지체 없이 안전하게 파기합니다.

3. 주민등록번호를 포함한 고유식별정보 및 사상·신념 등 민감정보는 법령에 근거가 있거나
   별도의 동의를 받은 경우에 한하여 최소한으로 처리합니다.

4. 회원가입 및 서비스 이용 과정에서는 주민등록번호를 사용하지 않고도 가입이 가능하도록 대체 수단을 제공하고 있으며,
   필수항목과 선택항목, 제3자 제공 및 마케팅 활용 여부를 명확히 구분하여 동의를 받고 있습니다.
   또한 선택항목 또는 제3자 제공에 동의하지 않더라도 서비스 이용에 제한이 없도록 하고 있습니다.

5. 개인정보는 원칙적으로 수집·이용 목적의 범위 내에서 처리되며,
   별도의 동의 또는 법적 근거가 있는 경우를 제외하고는 목적 외 이용이나 제3자 제공을 하지 않습니다.
   부득이하게 목적 외 이용 또는 제3자 제공이 발생하는 경우에는 관련 법령에 따라 그 법적 근거,
   이용 목적 및 범위 등을 사전에 안내하거나 홈페이지 등을 통해 공개합니다.
   또한 개인정보 처리 업무를 외부에 위탁하는 경우에는 위탁 업무의 내용 및 수탁자를 정보 주체에게 명확히 안내합니다.

6. 정보주체는 언제든지 자녀의 개인정보에 대한 열람, 정정, 삭제 및 처리정지 요청을 할 수 있으며,
   동의 또한 자유롭게 철회할 수 있습니다.

7. 당사는 개인정보의 분실, 유출, 훼손 등을 방지하기 위하여 관리적·기술적 보호조치를 시행하고 있으며,
   관련 내부 기준과 지침을 수립하여 이를 준수하고 있습니다.

8. 만 14세 미만 아동의 개인정보는 반드시 법정대리인의 동의를 받은 후 처리되며,
   관련 법적 기준을 엄격히 준수합니다.

9. 개인정보 침해에 대한 신고나 상담, 분쟁조정이 필요한 경우에는
   개인정보침해신고센터(http://1336.or.kr 또는 국번 없이 1336)를 이용하실 수 있습니다.
`,

      backSignup1() {
        router.push({ name: "signUp1", query: { type: "minor" } });
      },

      nextSignPage() {
        if (signUser.agentAgreeCheckbox) {
          router.push({ name: "signUp3", query: { type: "minor" } });
        } else {
          alert("화상외국어과정 참여를 위한 만 14세 미만 법정 대리인 동의서에 대해 동의 해주셔야 합니다.");
        }
      },
    });

    return {
      signUser,
    };
  },
};
</script>
<style scoped></style>
